module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_5.46f4ca80.pdf";